module.exports = __webpack_public_path__ + "img/11.ba331224.jpg";